import React, { useCallback, useEffect, useRef, useState } from "react";
import { SketchPicker } from "react-color";

const PRESET_COLORS = [
  "transparent",
  "#FFFFFF",
  "#D9D9D9",
  "#8C8C8C",
  "#000000",
  "#F5222D",
  "#FA541C",
  "#FA8C16",
  "#FADB14",
  "#A0D911",
  "#52C41A",
  "#13C2C2",
  "#1890FF",
  "#722ED1",
  "#EB2F96"
];

interface IWatermarkColorPickerProps {
  color: string;
  onChange: (hex: string) => void;
}

const WatermarkColorPicker: React.FC<IWatermarkColorPickerProps> = ({ color, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = useCallback(
    (event: MouseEvent) => {
      if (isOpen && containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    },
    [isOpen]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [handleOutsideClick]);

  return (
    <div ref={containerRef} className="watermark-color-picker">
      <button className="watermark-color-picker__trigger" onClick={() => setIsOpen(!isOpen)}>
        <div className="watermark-color-picker__swatch" style={{ backgroundColor: color }} />
        <span className="watermark-color-picker__hex">{color}</span>
      </button>
      {isOpen && (
        <div className="watermark-color-picker__popover">
          <SketchPicker color={color} onChange={(c) => onChange(c.hex.toUpperCase())} presetColors={PRESET_COLORS} />
        </div>
      )}
    </div>
  );
};

export default WatermarkColorPicker;
